/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type OnboardingTeamJoinCreateStep_viewer = {
    readonly user: {
        readonly id: string;
    } | null;
    readonly id: string;
    readonly " $fragmentRefs": FragmentRefs<"TeamJoinCreate_viewer">;
    readonly " $refType": "OnboardingTeamJoinCreateStep_viewer";
};
export type OnboardingTeamJoinCreateStep_viewer$data = OnboardingTeamJoinCreateStep_viewer;
export type OnboardingTeamJoinCreateStep_viewer$key = {
    readonly " $data"?: OnboardingTeamJoinCreateStep_viewer$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"OnboardingTeamJoinCreateStep_viewer">;
};



const node: ReaderFragment = (function () {
    var v0 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
    } as any;
    return {
        "argumentDefinitions": [
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "myCalendarIds"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "orgRelayId"
            }
        ],
        "kind": "Fragment",
        "metadata": null,
        "name": "OnboardingTeamJoinCreateStep_viewer",
        "selections": [
            {
                "alias": null,
                "args": null,
                "concreteType": "User",
                "kind": "LinkedField",
                "name": "user",
                "plural": false,
                "selections": [
                    (v0 /*: any*/)
                ],
                "storageKey": null
            },
            (v0 /*: any*/),
            {
                "args": [
                    {
                        "kind": "Variable",
                        "name": "myCalendarIds",
                        "variableName": "myCalendarIds"
                    },
                    {
                        "kind": "Variable",
                        "name": "orgRelayId",
                        "variableName": "orgRelayId"
                    }
                ],
                "kind": "FragmentSpread",
                "name": "TeamJoinCreate_viewer"
            }
        ],
        "type": "Viewer",
        "abstractKey": null
    } as any;
})();
(node as any).hash = '203df9ca931500fc64abc51f8bdf83c2';
export default node;
